
import { Observable } from 'rxjs/Rx';
// import { http } from 'vue-resource';
import Vue from 'vue'
export class AppConfig {

    config = null;
    env= null;    
    constructor() {}

    /**
     * Use to get the data found in the second file (config file)
     */
    getConfig(key) {
        return this.config[key];
    }

    /**
     * Use to get the data found in the first file (env file)
     */
    getEnv(key) {
        return this.env[key];
    }

    /**
     * This method:
     *   a) Loads "env.json" to get the current working environment (e.g.: 'production', 'development')
     *   b) Loads "config.[env].json" to get all env's variables (e.g.: 'config.development.json')
     */
    load() {
        return new Promise((resolve, reject) => {            
            
            // Vue.http.get('test.html').then((res)=>{
            //     console.log(res);
            // })

            // Vue.http.get('/assets/env.json').map( res => res.json() ).catch((error) => {
            //     console.log('Configuration file "env.json" could not be read');
            //     resolve(true);
            //     return Observable.throw(error.json().error || 'Server error');
            // }).subscribe( (envResponse) => {
            //     env = envResponse;
            //     let req = null;

            //     switch (envResponse.env) {
            //         case 'production': {
            //             req = request.get('/assets/config.' + envResponse.env + '.json');
            //         } break;

            //         case 'development': {
            //             req = request.get('/assets/config.' + envResponse.env + '.json');
            //         } break;

            //         case 'default': {
            //             console.error('Environment file is not set or invalid');
            //             resolve(true);
            //         } break;
            //     }

            //     if (req) {
            //         req
            //             .map( (res) => res.json() )
            //             .catch((error) => {
            //                 console.error('Error reading ' + envResponse.env + ' configuration file');
            //                 resolve(error);
            //                 return Observable.throw(error.json().error || 'Server error');
            //             })
            //             .subscribe((responseData) => {
            //                 this.config = responseData;
            //                 resolve(true);
            //             });
            //     } else {
            //         console.error('Env config file "env.json" is not valid');
            //         resolve(true);
            //     }
            // });

        });
    }
}


// WEBPACK FOOTER //
// ./src/services/app.config.js